import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Star } from 'lucide-react';
import axios from 'axios';
import './Hero.css';

export default function Hero() {
  const [stylistCount, setStylistCount] = useState(null);
  const [serviceCount, setServiceCount] = useState(null);

  useEffect(() => {
    axios.get('/api/stylists').then(r => setStylistCount(r.data.length)).catch(() => {});
    axios.get('/api/services').then(r => setServiceCount(r.data.length)).catch(() => {});
  }, []);

  return (
    <section className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-badge">
          <Sparkles size={14} />
          <span>Bem-vinda ao Studio</span>
        </div>
        <h1 className="hero-title">
          Patricia Pourroy
          <span className="hero-title-italic"> Studio</span>
        </h1>
        <p className="hero-tagline">
          Onde a beleza encontra o cuidado. Transformamos sua aparência com
          técnica, arte e muito carinho.
        </p>
        <div className="hero-stars">
          {[1,2,3,4,5].map(i => (
            <Star key={i} size={16} fill="#c9a96e" color="#c9a96e" />
          ))}
          <span>+500 clientes satisfeitas</span>
        </div>
        <div className="hero-actions">
          <Link to="/reservar" className="btn-primary">
            Agendar Horário
          </Link>
          <a href="#services" className="btn-secondary" onClick={e => {
            e.preventDefault();
            document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            Ver Serviços
          </a>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <span className="stat-number">15+</span>
            <span className="stat-label">Anos de Experiência</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-number">{stylistCount ?? '—'}</span>
            <span className="stat-label">{stylistCount === 1 ? 'Profissional Especializada' : 'Profissionais Especializadas'}</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-number">{serviceCount ?? '—'}</span>
            <span className="stat-label">Serviços Exclusivos</span>
          </div>
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <div className="scroll-dot" />
      </div>
    </section>
  );
}
